import { AxiosUtil } from '../utils/axios-util'
import { errorResponseNotification } from './notification-service'
import EventConstants from '../constants/EventConstants'

export const getPlans = () => {
  return AxiosUtil.get(EventConstants.PLAN).catch(err => {
    errorResponseNotification(err)
    throw err
  })
}
